module.exports = __webpack_public_path__ + "media/images/lb/942-a1d543b9aee5cf1ad430055ea0081fe7.svg";